import { capitalize, get } from "lodash";

export const getIcon = (icon = "") => {
    const capitalizeIconName = icon !== "" ? capitalize(icon) : "";
    const icons = {
        "Search": "fa-sharp fa-solid fa-magnifying-glass",
        "Facebook": "fa-brands fa-facebook-f",
        "Twitter": "fa-brands fa-x-twitter",
        "Youtube": "fa-brands fa-youtube",
        "Instagram": "fa-brands fa-instagram",
        "Tiktok": "fa-brands fa-tiktok",
        "Apple": "fa-brands fa-apple",
        "Podcasts": "fa-sharp-duotone fa-solid fa-wifi",
        "Amazon": "fa-brands fa-amazon",
        "Spotify": "fa-brands fa-spotify",
        "Share": "fa-regular fa-share-from-square",
        "Plus": "fa-solid fa-plus",
        "Feedback": "fa-regular fa-message",
        "Download": "fa-sharp fa-solid fa-arrow-down-to-line",
        "User": "fa-regular fa-user",
        "Calendar": "fa-solid fa-calendar-days",
        "Time": "fa-sharp fa-regular fa-clock",
        "Tag": "fa-sharp fa-regular fa-tag",
        "Shield": "fa-regular fa-shield",
        "Speaker": "fa-sharp fa-solid fa-volume-low",
        "Document": "fa-sharp fa-regular fa-file-lines",
        "Web": "fa-light fa-globe",
        "Video": "fa-solid fa-video",
        "Podcast": "fa-solid fa-podcast",
        "Play": "fa-solid fa-play",
        "Info": "fa-light fa-circle-info",
        "Episode": "fa-regular fa-clapperboard",
        "Arrow-left": "fa-regular fa-arrow-left",
        "Arrow-right": "fa-regular fa-arrow-right",
        "Pen": "fa-sharp fa-regular fa-pen-line",
        "Whatsapp": "fa-brands fa-whatsapp",
        "Linkedin": "fa-brands fa-linkedin-in",
        "Envelope": "fa-sharp fa-regular fa-envelope",
        "Star": "fa-solid fa-star-sharp",
        "Headphone": "fa-solid fa-headphones",
        "Circleuser": "fa-regular fa-circle-user",
        "Barcode": "fa-sharp fa-regular fa-barcode",
        "Building": "fa-sharp fa-solid fa-apartment",
        "Page": "fa-sharp fa-thin fa-memo",
        "Spikes": "fa-regular fa-ruler-horizontal",
        "Circle": "fa-light fa-circle-plus",
        "Check": "fa-light fa-circle-check",
        "Map": "fa-regular fa-map",
        "Location": "fa-solid fa-location-dot",
        "Layergroup": "fa-regular fa-layer-group",
        "Prevstep": "fa-sharp fa-solid fa-backward-step",
        "Nextstep": "fa-sharp fa-solid fa-forward-step",
        "Fullscreen": "fa-sharp fa-regular fa-expand",
        "Exitfullscreen": "fa-sharp fa-light fa-compress",
        "Photo": "fa-sharp fa-light fa-image",
        "Angle-right": "fa-regular fa-angle-right",
        "Close": "fa-regular fa-xmark",
        "Chevrondown": "fa-solid fa-chevron-down",
        "Triange": "fa-solid fa-triangle",
        "Delete": "fa-solid fa-trash-can",
        "Bell": "fa-regular fa-bell",
        "Bellsolid": "fa-sharp fa-solid fa-bell",
        "Setting": "fa-regular fa-gear",
        "Logout": "fa-sharp fa-solid fa-arrow-left-from-bracket",
        "Bars": "fa-regular fa-bars",
        "Network": "fa-solid fa-network-wired",
        "Lock": "fa-sharp fa-light fa-lock-keyhole",
        "Question": "fa-light fa-circle-question",
        "Caret": "fa-solid fa-caret-left",
        "Caretright": "fas fa-caret-right",
        "Caretdown": "fas fa-caret-down",
        "Caretup": "fas fa-caret-up",
        "Pencil": "fa-solid fa-pencil",
        "Eye": "fa-solid fa-eye",
        "Sympol": "fa-thin fa-l",
        "List": "fas fa-list",
        "Tick": "fa-solid fa-check",
        "Reload": "fa-sharp fa-solid fa-rotate-right",
        "Reverse": "fa-sharp fa-solid fa-rotate-left",
        "Listadd": "fa-solid fa-rectangle-history-circle-plus",
        "Restore": "fa-solid fa-recycle",
    };
    return get(icons, capitalizeIconName) ? get(icons, capitalizeIconName) : "";
}